import { ArticleHeading2, ArticleParagraph1, TDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ModalSidebar } from '../ModalSidebar';
import { clsx } from 'clsx';

interface IFormProps {
  currentStep: number;
  title: string;
  device: TDeviceType;
  form: React.ReactNode;
  image?: boolean;
  description?: string;
}

export const Form: React.FC<IFormProps> = ({ title, form, currentStep, device, image, description }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['progress-bar']} />
      <div className={styles['active-progress']} style={{ width: `${25 * currentStep}%` }} />
      {device !== 'desktop' && currentStep === 1 && <ModalSidebar step={0} />}
      {device !== 'desktop' && currentStep === 1 ? null : (
        <div className={styles['textblock']}>
          {image && <div className={styles['image']} />}
          <ArticleHeading2>{title}</ArticleHeading2>
          {((device !== 'desktop' && currentStep === 2) || currentStep !== 2) && (
            <ArticleParagraph1>{description}</ArticleParagraph1>
          )}
        </div>
      )}
      {form}
    </div>
  );
};
